module.exports = __webpack_public_path__ + "img/Danish.c4b1285a.svg";